import { YourCommunitiesRail } from "../../social";

/**
 * `HomeContextRail` - the desktop right rail at the home route: your
 * communities, matching the approved desktop shell. ContextRail mounts it only
 * at "/" after authentication settles with a user, so anonymous viewers issue
 * no community reads.
 */
export function HomeContextRail() {
  return <YourCommunitiesRail />;
}
